<template>
  <v-dialog v-model="dialog" max-width="500px">
    <v-card style="min-height:168px; height: 100%;">
      <v-card-title style="word-break: break-word; width: 97%;">
        {{ $tc('title.calculo_apuracao_nivel_familia') }}
      </v-card-title>
      <v-card-text>
        <v-container fluid px-0 py-0>
          <v-row>
            <v-col cols="12" >
              <v-data-table
               :headers="headers"
               :items="listaDeFamilias"
               class="elevation-1"
               hide-default-footer
               >
              </v-data-table>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click.native="close">{{ $t('label.ok') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { buscarFamiliasSelecionadas } from '@/common/resources/apuracao-contrato';

export default {
  data() {
    return {
      resource: this.$api.apuracaoContrato(this.$resource),
      headers: [
        { text: this.$tc('label.familia', 1), value: 'cod_nome_familia' },
      ],
      listaDeFamilias: [],
      dialog: false,
    };
  },
  methods: {
    open(idAcao) {
      this.buscarFamiliasSelecionadas(Number(idAcao));
    },
    close() {
      this.dialog = false;
    },
    buscarFamiliasSelecionadas(idAcao) {
      const params = {
        idAcao,
      };
      buscarFamiliasSelecionadas(params, this.$resource).then((res) => {
        this.listaDeFamilias = res.data;
        this.dialog = true;
      });
    },
  },
};
</script>
